import { render, staticRenderFns } from "./mbs_color.vue?vue&type=template&id=c656d1da&"
import script from "./mbs_color.vue?vue&type=script&lang=js&"
export * from "./mbs_color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports